import {useDispatch} from 'react-redux';
import {TAppDispatch} from 'store';

export function useAppDispatch() {
  return useDispatch<TAppDispatch>();
}
